export default class TrainingProvider {
  constructor(API) {
    this.api = API;
  }
  /*
  {
    "customerID": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
    "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
    "name": "string",
    "url": "string"
  }
  */
  async createTrainingProvider(providerObj) {
    const req = await this.api.newBaseRequest('POST');
    req.path = `/customer/${this.api.config.customerID}/trainingProvider/new`;
    req.body = providerObj;
    return await req.exec();
  }
  async updateTrainingProvider(providerObj) {
    const req = await this.api.newBaseRequest('PUT');
    req.path = `/customer/${this.api.config.customerID}/trainingProvider/${providerObj.id}`;
    req.body = providerObj;
    return await req.exec();
  }
  async deleteTrainingProvider(providerID) {
    const req = await this.api.newBaseRequest('DELETE');
    req.path = `/customer/${this.api.config.customerID}/trainingProvider/${providerID}`;
    return await req.exec();
  }
  async getTrainingProvider(providerID) {
    const req = await this.api.newBaseRequest('GET');
    req.path = `/customer/${this.api.config.customerID}/trainingProvider/${providerID}`;
    return await req.exec();
  }
  async getAllProviders() {
    const req = await this.api.newBaseRequest('GET');
    req.path = `/customer/${this.api.config.customerID}/trainingProviders`;
    return await req.exec();
  }
}
